// extracted by mini-css-extract-plugin
module.exports = {"side":"side___1aHpB","base":"base___1HKMu"};